import { AfterViewInit, ChangeDetectorRef, Component } from "@angular/core";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { ObbligoProvider } from "src/app/services/obbligo.provider";
/**
 * @example 
// {
// "props": {
//     "templateId": "icon-container",
//     "align": "right",
//     "iconTitle": "Riferimenti normativi",
//     "iconUrl": "fas fa-balance-scale" // fontawesome icon
//  }
// } 
*/
@Component({
  selector: "app-icon-container",
  templateUrl: "./icon-container.component.html",
  styleUrls: ["./icon-container.component.scss"],
})
export class IconContainerComponent implements AfterViewInit {
  /**
   * Data props definite in fase di configurazione da Dynamic Content.
   */
  data!: any;

  /**
   * L'allineamento dell'elemento
   */
  align: "center" | "start" | "end" = "end";

  /**
   * L'icona da visualizzare.
   */
  iconUrl: string = "";

  /**
   * Il titolo.
   */
  title: string = "";
  
  /**
   * Observable per i dettagli dell'obbligo.
   */
  obbligoDetails$ = this._obbligoProvider.obbligoDetails$;

  constructor(
    private _obbligoProvider: ObbligoProvider,
    private cdr: ChangeDetectorRef,
  ) {}

  /**
   * @inheritdoc
   */
  ngAfterViewInit(): void {
    if (this.data) {
      this.align = this.data.align;
      this.iconUrl = this.data.iconUrl;
      this.title = this.data.iconTitle;
      this.cdr.detectChanges();
    }
  }

  /**
   * Apre o chiude il popover.
   */
  togglePopover(popoverContent: NgbPopover, description: string): void {
    if (popoverContent.isOpen()) {
      popoverContent.close();
    } else {
      popoverContent.open({description: description});
    }
  }
}
